<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
          <div style="font-size:16px;">
            <p>我们是一家专业从事基因科学研究、分子诊断技术、DNA数据库建设和测序试剂盒研发的科技型技术企业。</p>
            <p>现正式开启招聘，诚邀各路英才加入！我们坚信，人才是公司最宝贵的财富。<br />在这里，你将：</p>
            <p><strong>投身前沿领域：</strong>在一个充满活力与机遇的平台上，参与核心项目，施展专业才华。</p>
            <p><strong>获得快速成长：</strong>享有开放的学习环境、清晰的职业路径以及与优秀团队共事的机会。</p>
            <p><strong>感受务实文化：</strong>成为我们平等、协作、追求卓越的团队一员，你的每一份贡献都会被看见和重视。</p>
            <p>
           我们正在寻找对行业有热情、对工作有责任心、具备创新思维和执行力的伙伴。如果你渴望挑战，期待在一个持续发展的舞台上实现个人价值，请加入我们，一起书写下一段精彩篇章！</p>
           <p><strong>期待你的简历，让我们看见闪闪发光的你！</strong></p>
           
          </div>
          <div class="textCenter" style="margin:100px 0;">
            <el-button type="primary" @click="golink('https://www.zhipin.com/gongsi/job/a3c5ba1e9192ae8d0Xd83d67GQ~~.html?ka=all-jobs-hot')">点击前往「博奥润康(许昌)医学检验实验室招聘」-BOSS直聘 (zhipin.com) <i
                class="fa fa-fw fa-arrow-right"></i></el-button>
          </div>
          <!-- <div v-if="pageContent" v-html="pageContent.content"></div>
          <div v-else>
            <p>页面暂无内容</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi } from '@/api'

export default {
  name: 'Join',
  data() {
    return {
      pageContent: ''
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(3)
  },
  methods: {
    golink(e){
      let url =e
      window.open(url, '_blank')
    },
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;

  .subbanner {
    background-size: 100% 100%;

    .title {
      font-size: 50px;
      letter-spacing: 0px;
      line-height: 32px;
    }

    span {
      position: relative;
      font-size: 30px;
      font-family: 'Times New Roman', Times, serif;
    }
  }


  img {
    max-width: 80%;
  }


}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    font-size: 1rem;
    line-height: 1.6;

    .subbanner {
      
      .container {
        padding-left: 1rem !important;
      }

      .title {
        font-size: 1.8rem !important;
      }

      span {
        font-size: 1.1rem !important;
      }
    }
    .submain {
      padding: 1rem 0 !important;


      p {
        font-size: 0.9rem !important;
        line-height: 1.7 !important;
        margin: 1rem 0 !important;
      }

      .textCenter {
        margin: 2rem 0 !important;
        
        .el-button {
          font-size: 0.8rem !important;
          padding: 0.8rem 1rem !important;
          white-space: break-spaces;
        }
      }
    }
  }
}
</style>